import TextField from "../../../../../../shared/TextField/TextField";
import Delete from "../../../../../../shared/Icons/Delete";
import Activity from "../../Activity";
import AsyncButton from "../../../../../../shared/Loading/AsyncButton";

const EquivalentActivitiesAndBenefit = (props) => {

  return (
    <>
      <div className="mb-3 space-y-2">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-800">
          Actividades equivalentes
        </p>
        {props.row.EquivalentActivities.map((activity) => (
          <div key={activity.Id} className={`flex items-center gap-2 ${props.isEditor ? '' : 'pl-2'}`}>
            {props.isEditor ? <Activity activity={activity} isEditor={true} setActivities={props.setActivities}/>
            : <ul className="list-disc pl-2">
                <li><Activity activity={activity} isEditor={false} setActivities={props.setActivities}/></li>
            </ul>}
            {props.isEditor && <AsyncButton light
                onClick={() => props.deleteActivity(props.row.Id, activity.Id)}
                className="p-1 text-red-500 hover:bg-red-50 rounded transition"
            >
                <Delete />
            </AsyncButton>}
          </div>
        ))}
        {props.isEditor && <button
            onClick={() => props.handleAddActivity()}
            className="w-full sm:w-auto px-4 py-2 text-sm border border-transparent text-white rounded
            bg-personalized hover:bg-gray-100 hover:text-personalized hover:border-personalized"
        >
            + Agregar actividad
        </button>}
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-800">
          Tipo de beneficio
        </p>
        <TextField
          isEditor={props.isEditor}
          id={props.row.Id}
          field="Benefit"
          value={props.row.Benefit || ''}
          setData={props.setLevels}
          className={'text-sm text-gray-700 whitespace-pre-line break-words'}
        />
      </div>
    </>
  );
};

export default EquivalentActivitiesAndBenefit;
